
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"d":"M10 22h13v3H10zM10 27h13v3H10zM10 32h13v3H10zM25 22h13v3H25zM25 27h13v5H25zM27 35h9l-3 2h-3.5z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Line 9",attrs:{"stroke":"#234652","d":"M6 17.5h36"}}),_c('path',{staticClass:"i-Vector",attrs:{"stroke":"#234652","stroke-linecap":"round","stroke-linejoin":"round","d":"M31.5 37a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13"}}),_c('path',{staticClass:"i-Vector_2",attrs:{"stroke":"#234652","stroke-linejoin":"round","d":"m42 41-6-6"}}),_c('path',{staticClass:"i-Vector 1",attrs:{"stroke":"#234652","stroke-linecap":"square","d":"M26.5 39H6V9h36v24"}})])
          )
        }
      }
    